module.exports = __webpack_public_path__ + "static/img/patent-swiper-4.36cd7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-4.png
// module id = qrb/
// module chunks = 1